import { DataBean } from "../../DataBean";


export class HealthContract extends DataBean {

    public async getHealthContractCatalog(idHealthContractType, idAccount, regexStr: any, date: any, enabled: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthContractCatalog_Number_Number_String_java.util.Date_Boolean_Number_Number", [idHealthContractType, idAccount, regexStr, date, enabled, page, recordsPerPage]);
    }
}